import {
  ModelDataTypeEnum,
  ModelDataTypeEnumRadioRendererMUI,
} from "components-care";

const serializer = (value: string) => value;

ModelDataTypeEnum.prototype.serialize = serializer;
ModelDataTypeEnumRadioRendererMUI.prototype.serialize = serializer;
